import { Request } from "./https";

export const CargoService = {
  get: () => {
    const newRequest = new Request(`get`, `nte-cargo`, {});
    return newRequest.sendXHR();
  },
};
